






















































































































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import {namespace} from 'vuex-class'
import Modal from '@/components/UI/Modal.vue';

const surveys = namespace('surveys')

@Component({
  name: "DetailSideBar",
  components: {Modal}
})
export default class DetailSideBar extends Vue {

  @Prop({type: Object, default: {}}) protected question!: any

  deleteQuestion:boolean = false

  get typeList(){
    return [
      {id: 'text', text: this.$t('surveys.types.typeText')},
      {id: 'select', text: this.$t('surveys.types.typeSelect')},
      {id: 'product', text: this.$t('surveys.types.typeProduct')}
    ]
  }
  get items(){
    return [
      {id: 'free_text_input', text: this.$t('surveys.form.text')},
      {id: 'free_number_input', text: this.$t('surveys.form.number')}
    ]
  }
  get specifyListSelect(){
    return [
      {id: 'single', text: this.$t('surveys.types.specifySingle')},
      {id: 'multi', text: this.$t('surveys.types.specifyMulti')}
    ]
  }
  get specifyItems(){
    return [
      {id: 'text', text: this.$t('surveys.form.text')},
      {id: 'number', text: this.$t('surveys.form.number')}
    ]
  }
  isOther: boolean = false
  otherType: string = 'free_text_input'
  order: number = 0
  type: string = ''

  get questionType() {
    return this.question.type == 'text_container' ?
        (this.question.order == '777777777' ? 'signature' : 'comment') : this.question.type
  }

  @Watch('question')
  getOther() {
    this.otherType = 'free_text_input'
    if (this.question.answers) {
      let other = this.question.answers.filter((a: any, index: number) => a.type == 'free_text_input' || a.type == 'free_number_input')
      if (other.length) this.otherType = other[0].type
      this.isOther = other.length
    }
    this.order = this.question.order
  }

  mounted() {
    if (this.question.answers) {
      let other = this.question.answers.filter((a: any, index: number) => a.type == 'free_text_input' || a.type == 'free_number_input')
      if (other.length) this.otherType = other[0].type
      this.isOther = other.length
    }
    this.order = this.question.order
  }

  changeOther() {
    if (this.isOther) {
      this.question.answers.unshift({
        order: 0,
        type: this.otherType,
        includeQuestions: [],
        value: ''
      })
    } else {
      this.question.answers = this.question.answers.filter((a: any) => {
        return a.type != 'free_text_input' && a.type != 'free_number_input'
      })
    }
    this.$emit('changeQuestion')
  }

  changeSpecify() {
    this.question.answerTitle = (this.question.specify == 'single') ? this.$t('surveys.form.oneAnswer') : this.$t('surveys.form.someAnswer')
    this.$emit('changeQuestion')
  }

  changeQuestionSpecify() {
    this.$emit('changeQuestion')
  }

  alertType(){

    if (this.question.type ==='product') {
      this.question.type = 'select'
      return}
   if(this.question.type !='product'){
     if(this.question.isProductAnswers && this.question.answers.length  ){
       this.deleteQuestion = true
     }
   }
  }

  changeType() {

    if (this.question.type == 'text') {
      this.question.isProductAnswers = false
      this.question.order = this.order
      this.isOther = false
      this.question.specify = 'text'
      this.question.answerTitle = this.$t('surveys.form.textAnswer')
      this.question.answers = [{
        value: '',
        includeQuestions: [],
        order: 0,
        type: 'regular'
      }]
    } else {
      if (this.question.type != 'product') {
        this.question.isProductAnswers = false
        this.question.order = this.order
        this.question.specify = 'single'
        this.question.answerTitle = this.$t('surveys.form.oneAnswer')
        this.question.answers = []
      } else {
        this.question.type = "select"
        this.question.isProductAnswers = true
        this.question.order = this.order
        this.question.specify = 'single'
        this.question.answerTitle = this.$t('surveys.form.oneAnswer')
        this.question.answers = []
        this.question.isProductAnswers = true
      }

    }
    console.log('Отсылаем: ', this.question)
    this.$emit('changeQuestion')
    this.deleteQuestion = false
  }

}
